import { render, staticRenderFns } from "./third-vendors-detail.vue?vue&type=template&id=d42200b4&"
import script from "./third-vendors-detail.vue?vue&type=script&lang=js&"
export * from "./third-vendors-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports